export default __webpack_public_path__ + "static/media/offersSvg.8babd169.svg";